import api from '@utils/api';
import config from '@/config';

const databaseAnalysisService = {
  // Get init data (database types, health statuses, units, etc.)
  getInit: async () => {
    return api.get(config.endpoints.databaseAnalyses.init);
  },

  // Get database analyses list with pagination
  getDatabaseAnalyses: async (params = {}) => {
    return api.get(config.endpoints.databaseAnalyses.list, params);
  },

  // Get database analysis by ID
  getDatabaseAnalysisById: async (id) => {
    return api.get(`${config.endpoints.databaseAnalyses.getById}/${id}`);
  },

  // Create new database analysis
  createDatabaseAnalysis: async (databaseAnalysisData) => {
    return api.post(config.endpoints.databaseAnalyses.create, databaseAnalysisData);
  },

  // Update database analysis
  updateDatabaseAnalysis: async (databaseAnalysisData) => {
    return api.put(`${config.endpoints.databaseAnalyses.update}/${databaseAnalysisData.id}`, databaseAnalysisData);
  },

  // Delete database analysis
  deleteDatabaseAnalysis: async (id) => {
    return api.delete(`${config.endpoints.databaseAnalyses.delete}/${id}`);
  },

  // Bulk delete database analyses
  bulkDeleteDatabaseAnalyses: async (ids) => {
    return api.delete(config.endpoints.databaseAnalyses.delete, {
      params: { ids }
    });
  },

  // Export to Excel
  exportDatabaseAnalysesToExcel: async (params = {}) => {
    const response = await api.post(config.endpoints.databaseAnalyses.exportExcel, params, {
      responseType: 'blob',
    });

    // Trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DatabaseAnalyses_${new Date().toISOString().slice(0,10)}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Excel file downloaded successfully' };
  },

  // Export to PDF
  exportDatabaseAnalysesToPdf: async (params = {}) => {
    const response = await api.post(config.endpoints.databaseAnalyses.exportPdf, params, {
      responseType: 'blob',
    });

    // Trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DatabaseAnalyses_${new Date().toISOString().slice(0,10)}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'PDF file downloaded successfully' };
  },

  // Get database usage report (aggregated from VNeIDQueryLog)
  getDatabaseUsageReport: async (params = {}) => {
    return api.post(config.endpoints.databaseAnalyses.usageReport, params);
  },

  // Export usage report to Excel
  exportDatabaseUsageReportToExcel: async (params = {}) => {
    const response = await api.post(config.endpoints.databaseAnalyses.usageReportExportExcel, params, {
      responseType: 'blob',
    });

    // Trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DatabaseUsageReport_${new Date().toISOString().slice(0,10)}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Usage report Excel file downloaded successfully' };
  },

  // Export usage report to PDF
  exportDatabaseUsageReportToPdf: async (params = {}) => {
    const response = await api.post(config.endpoints.databaseAnalyses.usageReportExportPdf, params, {
      responseType: 'blob',
    });

    // Trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DatabaseUsageReport_${new Date().toISOString().slice(0,10)}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Usage report PDF file downloaded successfully' };
  },
};

export default databaseAnalysisService;
